<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <!-- <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"></SearchField> -->

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :showTotal="true"
      :getTotal="getTotal" :btns="btns" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange"></Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'car',
      breadcrumb: [
        { name: "财务管理", path: `/finance/initialPayment` },
        { name: "预支款管理", path: `/finance/initialPayment` },
        { name: "费用详情" },
      ],
      formInline: {},
      formCtrl: [
        {
          ...this.ctrls.license
        },
      ],
      cols: [
        { prop: "license", label: "车牌号", minwidth: 120 },
      ],
      // getTotalProperty: ['paymoney'],
      getListUrl: 'payrecdetail',
      baseParams: ['id', 'repaytime'],
    };
  },
  methods: {
    setQueryParams() {
      const object = this.$route.query
      console.log(object.repaytime, object.id)
      this.id = object.id
      this.repaytime = object.repaytime
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          this.formInline[key] = object[key] || null;
        }
      }
      // console.log(this.formInline)
      this.getList()
    },
    getPrepaidType() {
      // console.log(id)
      let url = `car/prepaidType`
      const params = {}
      this.post(url, params, ({ msg, data }) => {
        if (msg === 'success' && data) {
          const arr = []
          data.map(v => {
            const o = {
              prop: v.enname,
              label: v.authname,
              align: 'right',
              className: 'pr30',
              width: '100px',
            }
            if (v.authname.length > 3) {
              o.width = 100
            }
            arr.push(o)
          })
          this.cols = [
            { prop: "license", label: "车牌号", minwidth: '110px' },
            { prop: "starttime", label: "装货日期", minwidth: '110px' },
            { prop: "doil", label: "现金加油", minwidth: '110px' },
            { prop: "moneydoil", label: "非现金加油", minwidth: '110px' },
            ...arr,
            { prop: "dtotal", label: "总费用（不含油卡加油）", minwidth: '110px' },
          ]
          this.getTotalProperty = [
            ...arr.map(v => v.prop), 'doil', 'moneydoil', 'total', 'dtotal'
          ]
          this.doLayout()
          this.$forceUpdate()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交数据失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getPrepaidType()
    this.setQueryParams();
    // this.getList();
    // if (this.$route.query.id) {
    //   this.showAllRecordBtn = true
    // }
    // this.$nextTick(this.getList);
  },
};
</script>

<style lang="less" scoped>
/deep/ .dialog {
  .el-dialog {
    .modal-scroll {
      height: 350px;

      .el-scrollbar__wrap {
        overflow-x: hidden;

        .el-form {
          padding-right: 50px;
        }

        .btns {
          margin-left: 110px;
        }
      }

      .is-horizontal {
        display: none;
      }
    }
  }
}

/deep/ .el-dialog .btns .mians {
  text-align: center;
}
</style>
